import React, { Component } from "react";
import { func, bool, shape, string } from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classNames from "classnames";
import Col from "react-bootstrap/lib/Col";

import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import AccountSummaryData from "pages/accounts/AccountSummaryData";
import AccountTokenConfirmation from "pages/accounts/AccountTokenConfirmation";
import I18n from "pages/_components/I18n";

import * as i18n from "util/i18n";

import { selectors as accountsSelectors } from "reducers/accounts";
import { selectors as sessionSelectors } from "reducers/session";
import { resizableRoute } from "pages/_components/Resizable";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";

const FORM_ID = "accounts.new.account";

class AccountsOpeningSummary extends Component {
    static propTypes = {
        isDesktop: bool,
        dispatch: func.isRequired,
        openingData: shape({}).isRequired,
        fullName: string.isRequired,
    };

    static defaultProps = {
        isDesktop: true,
    };

    componentDidMount() {
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { isDesktop, openingData } = this.props;
        if (
            isUxDashboardImprovementsEnabled() &&
            (prevProps.isDesktop !== isDesktop ||
                prevProps.openingData !== openingData ||
                prevProps.openingData?.returnToPending !== openingData?.returnToPending)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        if (isUxDashboardImprovementsEnabled()) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, isDesktop, openingData } = this.props;
        if (!openingData || !Object.keys(openingData).length) {
            return;
        }
        const uxDashboardImprovements = isUxDashboardImprovementsEnabled();
        const headerTitle = i18n.get(openingData?.returnToPending ? "modify.account" : "new.account");
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell: uxDashboardImprovements,
            isDesktop,
            scopes: ["accountOpeningSummary"],
            headerTitle,
            goBackPath: "/accountOpening/back",
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push("/accountOpening/back"));
    };

    centerContentMobile = () => {
        const { openingData } = this.props;
        return (
            <div className="title-account-header-multiline-background-blue w-100">
                <h1>{i18n.get(openingData?.returnToPending ? "modify.account" : "new.account")}</h1>
            </div>
        );
    };

    render() {
        const { dispatch, isDesktop, openingData, fullName } = this.props;
        const uxDashboardImprovements = isUxDashboardImprovementsEnabled();
        const showLegacyHead = !uxDashboardImprovements || isDesktop;

        if (!openingData) {
            dispatch(push("/accountOpening"));
            return <></>;
        }

        return Object.keys(openingData).length ? (
            <>
                {!uxDashboardImprovements && <Notification scopeToShow="accountOpeningSummary" />}
                {showLegacyHead && (
                    <div className={isDesktop ? "admin-detail-head px-0" : ""}>
                        <Head
                            onBack={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                            {...(!isDesktop && {
                                closeLinkTo: "/accountOpening",
                            })}
                        />
                        {isDesktop && (
                            <div className="view-title">
                                <h1>{i18n.get(openingData?.returnToPending ? "modify.account" : "new.account")}</h1>
                            </div>
                        )}
                    </div>
                )}
                <MainContainer viewPageClassName="confirmation__container">
                    <div className="above-the-fold">
                        <Container
                            className={classNames({
                                "flex-grow align-items-center container-white py-4": !isDesktop,
                            })}
                            gridClassName={
                                isDesktop ? "confirmation__form confirmation__box mb-0 pt-5" : "form-content"
                            }>
                            <Col className="col-12 col-xl-12" lg={12} md={9} sm={12}>
                                <div
                                    className={classNames("admin-content-center", {
                                        "mb-3": !isDesktop,
                                    })}>
                                    <I18n
                                        id="account.opening.summary.checkInfo.label"
                                        component={!isDesktop ? "h2" : "h1"}
                                        componentProps={{ className: classNames({ "f-size-35": !isDesktop }) }}
                                    />
                                </div>
                                <AccountSummaryData
                                    openingData={openingData}
                                    FORM_ID={FORM_ID}
                                    fullName={fullName}
                                    isDesktop={isDesktop}
                                />
                            </Col>
                        </Container>
                        <AccountTokenConfirmation isDesktop={isDesktop} />
                    </div>
                </MainContainer>
            </>
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    openingData: accountsSelectors.getAccountOpeningData(state),
    userId: sessionSelectors.getUser(state).userId,
    fullName: sessionSelectors.getUser(state).userFullName,
});

export default compose(connect(mapStateToProps), resizableRoute)(AccountsOpeningSummary);
